export default "__VITE_ASSET__3b066984__"